import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState as rootState,
} from '../../../utils/redux';
import { APPOINTMENT_CONSENTS_MODAL } from '../../healthboard/appointment-consent-modal';
import { APPOINTMENT_PROGRESS_TYPES } from '../progress-types';

export const consts = createReqConsts('appointment-form', 'consent-req');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'appointments',
  type: 'get',
  slug: [
    'consents',
    {
      type: 'payload.query',
      queryParameter: 'service_id',
      selector: 'serviceId',
    },
    {
      type: 'payload.query',
      queryParameter: 'location_id',
      selector: 'locationId',
    },
    {
      type: 'payload.query',
      queryParameter: 'visit_type_code',
      selector: 'visitTypeCode',
    },
    {
      type: 'payload.query',
      queryParameter: 'user_id',
      selector: 'userId',
    },
  ],
});

const defaultRequestReducer = createReqReducer(consts);

const initialState = {
  ...rootState,
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case consts.SEND: {
      return {
        ...initialState,
        sending: true,
      };
    }

    case consts.SUCCEED: {
      return {
        ...state,
        sending: false,
        succeed: true,
        data: payload,
      };
    }

    case consts.CLEAR: {
      return {
        ...initialState,
      };
    }

    case APPOINTMENT_CONSENTS_MODAL.CLOSE:
    case APPOINTMENT_PROGRESS_TYPES.CLEAR: {
      return initialState;
    }

    default: {
      return defaultRequestReducer(state, action);
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/requests/consent-req.js